var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(_vm.user)?_c('div',[_c('HomeDebugModeToggle'),_c('HomeWelcomeMessage'),_c('HomeStudentList'),_c('HomeGroupList'),_c('HomeMemberContent'),_c('HomeLinkedAccount')],1):_c('div',{staticClass:"container text-center p-4"},[_c('div',{staticClass:"custom-spinner pull-center mt-2"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }